import React, { useState, useEffect } from 'react';
import { PropagateLoader } from 'react-spinners';
import config from '../../config';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [iframeLoading, setIframeLoading] = useState([true, true, true, true]); // For each iframe panel
  const [selectedState, setSelectedState] = useState(""); // State to hold the selected state
  const [stateList, setStateList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]); // List of departments
  const [selectedDepartment, setSelectedDepartment] = useState(""); // Selected department


  // Fetch states on component mount (unconditionally)
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/registration/state`); // Assuming '/state' is the backend endpoint
        const data = await response.json();
        setStateList(data); // Set the fetched states to stateList
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    };
  
    fetchStates(); // Call the function to fetch states on component mount
  }, []); 

  // Fetch departments on component mount (unconditionally)
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/consultation/department`);
        const data = await response.json();
        console.log(data, "data");
  
        // Ensure the data is an array before setting the state
        if (Array.isArray(data)) {
          setDepartmentList(data);
        } else {
          console.error('Expected an array of departments, but received:', data);
          setDepartmentList([]); // Fallback to empty array if the data structure is incorrect
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
        setDepartmentList([]); // Fallback to empty array on error
      }
    };
  
    fetchDepartments();
  }, []);

  // Simulating loading completion after 3 seconds
  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Set loading to false after data is "loaded"
    }, 3000); // Simulate a 3-second loading period
  }, []);

  const handleIframeLoad = (index) => {
    setIframeLoading((prev) => {
      const newLoading = [...prev];
      newLoading[index] = false;
      return newLoading;
    });
  };

  // Early return to show loading spinner while data is being fetched
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-white-900">
        <PropagateLoader color="#50cfc0" size={15} />
      </div>
    );
  }



  return (
    <div className="bg-white-900 min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <style>
          {`
            @keyframes marquee {
              0% { transform: translateX(100%); }
              100% { transform: translateX(-100%); }
            }

            .marquee {
              display: inline-block;
              white-space: nowrap;
              box-sizing: border-box;
              animation: marquee 30s linear infinite;
              color: blue; /* Text color */
              padding: 8px;
              margin-bottom: 20px;
            }
          `}
        </style>
        
        <div className="flex justify-center overflow-hidden">
          <div className="marquee">
            ⚡ Welcome to the Hospital Management Software! Stay updated with real-time patient information and key metrics. |
            Manage hospital operations seamlessly and efficiently.🚀
          </div>
        </div>

        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-bold text-white">Dashboard</h1>
        </div>

      
        {/* iframe Panels Section */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-8">
          {[1].map((panelId, index) => (
            <div key={panelId} className="bg-gray-800 shadow-lg rounded-xl overflow-hidden relative">
              {iframeLoading[index] && (
                <div className="absolute inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50">
                  <PropagateLoader color="#50cfc0" size={10} />
                </div>
              )}
              <iframe
                src={`https://avatargrafana.cloudgentechnologies.com/d-solo/fe8v4jafduoe8c/hmsuat?orgId=1&panelId=${panelId}`}
                width="100%"
                height="350"
                frameBorder="0"
                onLoad={() => handleIframeLoad(index)} 
              />
            </div>
          ))}
        </div>

          <div className="mb-8">
          <div className="flex items-center space-x-4 mt-5">
      <label className="text-lg font-bold text-gray-900 ">State:</label>
      <select
        className="p-2 text-sm bg-gray-800 text-white border border-teal-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 transition-all duration-200"
        onChange={(e) => setSelectedState(e.target.value)}
        value={selectedState}
      >
        <option value="">Selected State</option>
        {stateList.map((state, index) => (
          <option key={index} value={state.state}>
            {state.state}
          </option>
        ))}
      </select>
    </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-8">
          {[2].map((panelId, index) => (
            <div key={panelId} className="bg-gray-800 shadow-lg rounded-xl overflow-hidden relative">
              {iframeLoading[index] && (
                <div className="absolute inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50">
                  <PropagateLoader color="#50cfc0" size={10} />
                </div>
              )}
              <iframe
                src={`https://avatargrafana.cloudgentechnologies.com/d-solo/fe8v4jafduoe8c/hmsuat?orgId=1&&var-state=${selectedState}&panelId=${panelId}`}
                width="100%"
                height="350"
                frameBorder="0"
                onLoad={() => handleIframeLoad(index)} 
              />
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          {[5,4].map((panelId, index) => (
            <div key={panelId} className="bg-gray-800 shadow-lg rounded-xl overflow-hidden relative">
              {iframeLoading[index] && (
                <div className="absolute inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50">
                  <PropagateLoader color="#50cfc0" size={10} />
                </div>
              )}
              <iframe
                src={`https://avatargrafana.cloudgentechnologies.com/d-solo/fe8v4jafduoe8c/hmsuat?orgId=1&panelId=${panelId}`}
                width="100%"
                height="350"
                frameBorder="0"
                onLoad={() => handleIframeLoad(index)} 
              />
            </div>
          ))}
        </div>

        <div className="mb-8">
  <div className="flex items-center space-x-4 mt-5">
    <label className="text-lg font-medium text-gray-900">Department:</label>
    <select
      className="p-2 text-sm bg-gray-800 text-white border border-teal-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 transition-all duration-200"
      onChange={(e) => setSelectedDepartment(e.target.value)}
      value={selectedDepartment}
    >
      <option value="">Select Department</option>
      {departmentList.map((department, index) => (
        <option key={index} value={department.department_name}>
          {department.department_name}
        </option>
      ))}
    </select>
  </div>
</div>

<div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-8">
  {[3].map((panelId, index) => (
    <div key={panelId} className="bg-gray-800 shadow-lg rounded-xl overflow-hidden relative">
      {iframeLoading[index] && (
        <div className="absolute inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50">
          <PropagateLoader color="#50cfc0" size={10} />
        </div>
      )}
      <iframe
        src={`https://avatargrafana.cloudgentechnologies.com/d-solo/fe8v4jafduoe8c/hmsuat?orgId=1&&var-department_name=${selectedDepartment}&panelId=${panelId}`}
        width="100%"
        height="350"
        frameBorder="0"
        onLoad={() => handleIframeLoad(index)} 
      />
    </div>
  ))}
</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
  {[6,7].map((panelId, index) => (
    <div key={panelId} className="bg-gray-800 shadow-lg rounded-xl overflow-hidden relative">
      {iframeLoading[index] && (
        <div className="absolute inset-0 flex justify-center items-center bg-gray-700 bg-opacity-50">
          <PropagateLoader color="#50cfc0" size={10} />
        </div>
      )}
      <iframe
        src={`https://avatargrafana.cloudgentechnologies.com/d-solo/fe8v4jafduoe8c/hmsuat?orgId=1&&var-department_name=${selectedDepartment}&panelId=${panelId}`}
        width="100%"
        height="350"
        frameBorder="0"
        onLoad={() => handleIframeLoad(index)} 
      />
    </div>
  ))}
</div>

      </div>
    </div>
  );
};

export default Dashboard;
